module.exports = __webpack_public_path__ + "img/coin_in_hand.b4437c5b.svg";